const BASE_URL = process.env.BASE_URL

export function isProduction() {
  return (process.env.NEXT_PUBLIC_APP_ENV == "production") ? true : false;
}
function baseUrl(subdomain?: string) {
  if (!BASE_URL) {
    throw "Missing BASE_URL Environment Variable";
  }

  if (subdomain) {
    return BASE_URL.replace("www", subdomain);
  } else {
    return BASE_URL;
  }
}

export function pwaHomeUrl(clubId: string) {
  return baseUrl(`club${clubId}`);
}

export function pwaUserInquiryPath() {
  return '/anfragen';
}

export function pwaPollPath(id:string, showResults?: boolean ) {
  const url = `/umfrage/${id}`;
  if(showResults == undefined) {
    return url;
  }
  else {
    return `${url}?showResults=${showResults}`
  }
}

export function pwaEventPath(id: string, teamId?: string) {
  const url = `/termin/${id}`;
  if(teamId == undefined) {
    return url;
  }
  else {
    return `${url}?teamId=${teamId}`
  }
}


export function pwaEventsPath() {
  return '/termine';
}

export function pwaTeamGamePath(teamId: string, gameId: string) {
  return `/team/${teamId}/spiel/${gameId}`;
}

export function tickarooBackendNotificationPath() {
  return isProduction() ? 'https://enterprise.tickaroo.com/api/v2/notifications/create' : 'https://enterprise-staging.tickaroo.com/api/v2/notifications/create';
}

export function sqsNotificationQueueUrl() {
  return isProduction() ? "https://sqs.eu-central-1.amazonaws.com/906559346761/vereinsheim-production-pushNotification" : "https://sqs.eu-central-1.amazonaws.com/062013962025/vereinsheim-staging-pushNotification";
}

export function tickarooCreateTickerPath() {
  return isProduction() ? 'https://www.tickaroo.com/api/v5/write/ticker/create.json?client_id=666816c5c5350d3ea146abbf&client_secret=CYKkx3x-iebK16zPtSLNsEOIaIk7jK3duk0AIBUYa6Y' : 'https://www.tickaroo.com/api/v5/write/ticker/create.json?client_id=660e6360ce1dddf3d3763669&client_secret=rx0g6HMvjZK46yBI1Ew1qw-V3U2xWPqAIpZBis7t2mM';
}

export function tickarooLinkTickerPath() {
  return isProduction() ? 'https://www.tickaroo.com/api/v6/guest-access/make-login-link-with-temp-guest-access.json?client_id=666816c5c5350d3ea146abbf&client_secret=CYKkx3x-iebK16zPtSLNsEOIaIk7jK3duk0AIBUYa6Y' : 'https://www.tickaroo.com/api/v6/guest-access/make-login-link-with-temp-guest-access.json?client_id=660e6360ce1dddf3d3763669&client_secret=rx0g6HMvjZK46yBI1Ew1qw-V3U2xWPqAIpZBis7t2mM';
}

export function tickarooReadTickerPath(tickerId: string) {
  return isProduction() ? `https://www.tickaroo.com/api/v6/sync/load_ticker.json?local_id=${tickerId}&client_id=666816c5c5350d3ea146abbf&client_secret=CYKkx3x-iebK16zPtSLNsEOIaIk7jK3duk0AIBUYa6Y` : `https://www.tickaroo.com/api/v6/sync/load_ticker.json?local_id=${tickerId}&client_id=660e6360ce1dddf3d3763669&client_secret=rx0g6HMvjZK46yBI1Ew1qw-V3U2xWPqAIpZBis7t2mM`;
}

export function tickarooOrganizationId() {
  return isProduction() ? '6668160db88e4bfff89794d0' : '660e62a7ce1ddd224676364f';
}
export function kickerGetAllClubsWithFunctionsUrl() {
  return isProduction() ? 'https://apigateway.kicker-amateurfussball.de/Organization/GetAllClubsWithFunctions' : 'https://apigateway.stage.kicker-amateurfussball.de/Organization/GetAllClubsWithFunctions';
}

export function kickerSmaBaseUrl() {
  return isProduction() ? 'https://sma2.socialmediahub.de/api/feed/entity_infos' : 'https://kicker-sma-dev.mobivention.eu/api/feed/entity_infos';
}
